import React, { useEffect, useState } from 'react';
import axios from 'axios';
import IntranetLayout from './IntranetLayout';
import { Mail, Trash2 } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const IntranetMessages = () => {
  const [contacts, setContacts] = useState([]);
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  const fetchContacts = () => axios.get(`${API}/contact`, { headers }).then(r => setContacts(r.data)).catch(console.error);
  useEffect(() => { fetchContacts(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <IntranetLayout>
      <div className="space-y-4">
        <div>
          <h2 className="font-heading text-2xl font-extrabold text-slate-900">Messages</h2>
          <p className="text-sm text-slate-500">{contacts.length} messages reçus</p>
        </div>

        <div className="space-y-3">
          {contacts.length === 0 ? (
            <div className="bg-white rounded-xl border border-slate-200 p-10 text-center text-slate-400">Aucun message</div>
          ) : contacts.map(c => (
            <div key={c.id} className="bg-white rounded-xl border border-slate-200 p-4" data-testid={`message-${c.id}`}>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-sky-50 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Mail size={18} className="text-sky-500" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="font-semibold text-slate-900 text-sm">{c.name}</span>
                    <span className="text-xs text-slate-500">{c.email}</span>
                    {c.phone && <span className="text-xs text-slate-400">{c.phone}</span>}
                  </div>
                  <p className="text-sm text-slate-600 whitespace-pre-line">{c.message}</p>
                  <p className="text-xs text-slate-400 mt-1">{new Date(c.created_at).toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' })}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </IntranetLayout>
  );
};

export default IntranetMessages;
